<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="inspectDeviceManage">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 点检设备管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
          <button class="PurpleSmBtn" @click="openImportModal">导入</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="消防系统">
                <el-select :popper-append-to-body="false" v-model="seefrom.fireControlSystem" placeholder="请选择消防系统" clearable>
                  <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型:">
                <el-input placeholder="请输入设备类型" v-model="seefrom.deviceType"></el-input>
              </el-form-item>
              <el-form-item label="区域选择">
                <el-input placeholder="请选择区域" v-model="seefrom.areaName" @focus="changeAreaMode(2)"></el-input>
                <!-- 区域树 -->
                <mountPoint :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @regionTreeData="selRegionData"></mountPoint>
              </el-form-item>
              <el-form-item label="设备编号:">
                <el-input placeholder="请输入设备编号" v-model="seefrom.deviceCode"></el-input>
              </el-form-item>
              <br>
              <el-form-item label="二维码:">
                <el-input placeholder="请输入二维码" v-model="seefrom.qrCode"></el-input>
              </el-form-item>
              <el-form-item label="到期提醒">
                <el-select :popper-append-to-body="false" v-model="seefrom.expiredNotice" placeholder="请选择" clearable>
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属部门">
                <el-select :popper-append-to-body="false" v-model="seefrom.deptId" placeholder="请选择" clearable>
                  <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="负责人:">
                <el-input placeholder="请输入" v-model="seefrom.contactPerson"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align, width}) in config" :key="prop.toString()" :width="width"></el-table-column>
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <el-link :icon="scope.row.status === 0 ? 'iconfont icontingyong' : 'iconfont iconcheck1'" type="text" size="small"
                  @click="changeStatus(scope.row)">{{scope.row.status === 0 ? '停用' : '启用'}}</el-link>
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.row)">查看</el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.row)">编辑</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 新增编辑 -->
    <add-edit-dialog v-model="addModal" :status="addStatus" :data="detailData" @refresh="getTableData"></add-edit-dialog>
    <el-dialog class="editDialog" title="导入" :visible.sync="importModal" :close-on-click-modal="false">
      <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
        <el-form-item label="导入文件">
          <input id="test" type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" accept=".xlsx, .xls" />
        </el-form-item>
      </el-form>
      <el-link style="color: #4c6bc3; font-size: 12px; margin: 0 0 0 290px" @click.stop="downLoadTemplate">导入模板下载：点检设备导入模板.xlsx</el-link>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelButton" @click="importModal = false">取 消</el-button>
        <el-button class="confirmButton" type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addEditDialog from './addEditDialog'
export default {
  name: 'inspectDeviceManage',
  data() {
    return {
      tabName: 'inspectDeviceManage',
      form_jsgl: {},
      items: [],
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      addModal: false,
      addStatus: 'adding',
      detailData: {},
      systemList: [],
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true,
      //选择区域树模式 查询 ？ 新增 ？
      areaMode: 1,
      statusList: [
        {
          label: '是',
          value: 0
        },
        {
          label: '否',
          value: 1
        }
      ],
      periodList: [
        {
          label: '每日',
          value: 0
        },
        {
          label: '每周',
          value: 1
        },
        {
          label: '每月',
          value: 2
        }
      ],
      departmentList: [],
      importModal: false,
      addEquipment: {},
      rules: {},
      addArr: [],
      submitLoading: false
    }
  },
  computed: {
    config() {
      return [
        {
          prop: 'deviceCode',
          label: '编号'
        },
        {
          prop: 'name',
          label: '设备名称',
          width: 200
        },
        {
          prop: 'fireControlSystem',
          label: '消防系统'
        },
        {
          prop: 'deviceType',
          label: '设备类型'
        },
        {
          prop: 'deptName',
          label: '所属部门'
        },
        {
          prop: 'areaName',
          label: '区域名称'
        },
        {
          prop: 'qrCode',
          label: '二维码'
        },
        {
          prop: 'contactPerson',
          label: '负责人'
        },
        {
          prop: 'expiredNoticeName',
          label: '到期提醒'
        },
        {
          prop: 'taskCycleName',
          label: '巡检周期'
        }
      ]
    }
  },
  components: {
    searchForm: () => import('public/searchForm'),
    mountPoint: () => import('public/mountPoint'),
    addEditDialog
  },
  mounted() {
    this.getTableData()
    this.getSystemList()
    this.getDepart()
  },
  methods: {
    getDepart() {
      this.$axiosget('operation/deptApi/getDeptList').then((res) => {
        this.departmentList = res.data.data[0].children
      })
    },
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'pointInspectFireCS'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    reset() {
      this.seefrom = {}
    },
    getTableData() {
      this.$axiosget('extra/pointInspectDevice/page', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        this.tableData = res.data.data.list.map((item) => {
          return {
            ...item,
            expiredNoticeName: this.statusList.find(
              (bitem) => bitem.value == item.expiredNotice
            ).label,
            taskCycleName: this.periodList.find(
              (bitem) => bitem.value == item.taskCycle
            ).label
          }
        })
        this.nTotal = res.data.data.total
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true
      if (mode === 2) this.areaTreeMode = false
      this.areaMode = mode
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode
      if (mode === 2) {
        this.seefrom.areaId = a.id
        this.seefrom.areaName = a.name
      }
    },
    //新增
    addnew() {
      this.addStatus = 'adding'
      this.addModal = true
    },
    // 编辑
    edit(row) {
      let data = _.cloneDeep(row)
      this.detailData = data
      this.addStatus = 'editing'
      this.addModal = true
    },
    check(row) {
      let data = _.cloneDeep(row)
      this.detailData = data
      this.addStatus = 'readonly'
      this.addModal = true
    },
    changeStatus(row) {
      let mag, status
      if (row.status == 1) {
        mag = '启用'
        status = 0
      } else {
        mag = '停用'
        status = 1
      }

      this.$confirm(mag + '该设备?', '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosput('extra/pointInspectDevice', {
          id: row.id,
          status: status
        }).then((res) => {
          if (res.data.status == 10000) {
            this.getTableData()
            this.$message({
              type: 'success',
              message: `${mag}成功！`
            })
          }
        })
      })
    },
    deleteMsg(row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('extra/pointInspectDevice', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.getTableData()
            this.$message.success('删除成功!')
          }
        })
      })
    },
    openImportModal() {
      this.addArr = []
      var test = document.getElementById('test')
      if (test) {
        test.value = ''
      }
      this.addEquipment = {}
      this.submitLoading = false
      this.importModal = true
      if (this.$refs['addEquipment']) {
        this.$refs['addEquipment'].clearValidate()
      }
    },
    downLoadTemplate() {
      this.$axiospost(
        `extra/pointInspectDevice/export/template?companyId=${localStorage.getItem(
          'companyId'
        )}&userId=${localStorage.getItem(
          'userId'
        )}&userAccount=${localStorage.getItem('userAccount')}`,
        {
          headers: { 'Content-Type': 'application/x-msdownload' }
        }
      ).then((res) => {
        this.$message.success('下载成功!')
      })
    },
    //上传文件
    getFile(event) {
      let file = event.target.files
      this.addArr = []
      var imgName = file[file.length - 1].name
      var idx = imgName.lastIndexOf('.')
      if (idx != -1) {
        var ext = imgName.substr(idx + 1).toUpperCase()
        ext = ext.toLowerCase()
        if (ext === 'xlsx' || ext === 'xls') {
          this.addArr = file[file.length - 1]
        } else {
          this.$message.error('文件类型错误！')
        }
      }
    },
    //确认
    submitForm() {
      if (this.addArr.length === 0) {
        this.$notify({
          message: '请选择文件！',
          type: 'warning'
        })
        return
      } else {
        this.submitLoading = true
        let formData = new FormData()
        formData.append('file', this.addArr)
        this.$refs['addEquipment'].validate((valid) => {
          if (valid) {
            this.$axiospost(
              'extra/pointInspectDevice/batchImport',
              formData
            ).then((res) => {
              this.submitLoading = false
              if (res.data.status == 10000) {
                this.getTableData()
                this.importModal = false
                if (!_.isEmpty(res.data.data.errList)) {
                  setTimeout(() => {
                    this.$message.error(
                      `失败的表格序号为: ${res.data.data.errList.join(',')}`
                    )
                  }, 500)
                }
                this.$message.success(
                  '导入成功' +
                    res.data.data.success +
                    '条，失败' +
                    res.data.data.error +
                    '条'
                )
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/deviceInspect/inspectDeviceManage/index.vue